import angular from 'angular';

export default function ConfirmBeginRiskAssessmentDialogController(
  $rootScope,
  $scope,
  $q,
  loaderService,
  ssDialogService,
  vmDataService,
  orgDataService,
  userService,
  performRiskAssessmentDialog
) {
  const vm = this;

  vm.handleConfirmBeginRiskAssessmentFormSubmit = _handleConfirmBeginRiskAssessmentFormSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  function _handleConfirmBeginRiskAssessmentFormSubmit($event) {
    _closeDialog().then(() => {
      const userId = userService.user.userId;
      const prefValue = vm.dontShowAgain === true;
      orgDataService.saveUserPreference(userId, 'DoNotShowRiskConfirm', prefValue, false)
        .then(() => {
          loaderService.showViewLoader = true;
          vmDataService.getRiskCategories().then((riskCategoriesResponse) => {
            vmDataService.getAssessmentQuestions(vm.product.productId).then((assessmentAnswerResponse) => {
              const riskCategories = riskCategoriesResponse.data.result;
              const assessmentAnswers = assessmentAnswerResponse.data.result;

              angular.forEach(riskCategories, (riskCategory) => {
                angular.forEach(assessmentAnswers, (assessmentAnswer) => {
                  if (riskCategory.riskCategoryId === assessmentAnswer.riskCategoryId) {
                    riskCategory.selectedScoreValue = assessmentAnswer.riskCategoryScore;
                    riskCategory.note = assessmentAnswer.note;
                  }
                });
              });

              showPerformRiskAssessmentDialog($event, {
                vendor: vm.vendor,
                product: vm.product,
                riskCategories,
                assessmentAnswers,
              });
              loaderService.showViewLoader = false;
            });
          });
        });
    });
  }

  function showPerformRiskAssessmentDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.performRiskAssessmentDialog = ssDialogService.alert(
      performRiskAssessmentDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.performRiskAssessmentDialog);
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmBeginRiskAssessmentDialog);
  }
}

ConfirmBeginRiskAssessmentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'loaderService',
  'ssDialogService',
  'vmDataService',
  'orgDataService',
  'userService',
  'performRiskAssessmentDialog'
];
